import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.questions');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-questions',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.questions/view.scss */
:host {
  display: block;
  height: 100%;
  overflow-y: auto;
}`],
})
export class PageAdminQuestionsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    // --- 탭 관리 ---
    public tab: string = 'list';

    // --- 필터 ---
    public subjects: any[] = [];
    public chapters: any[] = [];
    public topics: any[] = [];
    public filter: any = {
        subject_id: '',
        chapter_id: '',
        topic_id: '',
        question_type: '',
        difficulty_min: '',
        difficulty_max: '',
        source_type: '',
        keyword: '',
        page: 1,
        dump: 20
    };

    // --- 목록 ---
    public questions: any[] = [];
    public totalCount: number = 0;
    public loading: boolean = false;

    // --- 등록/수정 폼 ---
    public formMode: string = 'create'; // create | edit
    public form: any = this.emptyForm();

    // --- 통계 ---
    public statsData: any = null;

    // --- 대량 등록 ---
    public bulkJson: string = '';
    public bulkResult: any = null;
    public jsonExample: string = '[{"subject_id":"korean","chapter_id":"kr-01","question_type":"multiple_choice","difficulty":3,"content":"다음 중 고조선의 법에 해당하지 않는 것은?","options":["노비로 삼는다","곡물로 배상한다","사형에 처한다","유배를 보낸다","벌금을 낸다"],"answer":"4","explanation":"고조선의 8조법에는 유배 규정이 없습니다.","source_type":"qualification","grade_target":["middle2","high"]}]';

    // --- 상수 ---
    public questionTypes = [
        { value: 'multiple_choice', label: '5지선다' },
        { value: 'ox', label: 'OX' },
        { value: 'ordering', label: '순서배열' },
        { value: 'matching', label: '연결하기' },
        { value: 'short_answer', label: '단답형' }
    ];

    public difficulties = [
        { value: 1, label: '⭐ 매우 쉬움' },
        { value: 2, label: '⭐⭐ 쉬움' },
        { value: 3, label: '⭐⭐⭐ 보통' },
        { value: 4, label: '⭐⭐⭐⭐ 어려움' },
        { value: 5, label: '⭐⭐⭐⭐⭐ 매우 어려움' },
        { value: 6, label: '🔥 최상' }
    ];

    public sourceTypes = [
        { value: 'suneung', label: '수능 기출' },
        { value: 'mockexam', label: '모의고사' },
        { value: 'qualification', label: '한국사능력검정' },
        { value: 'textbook', label: '교과서' },
        { value: 'self', label: '자체 출제' }
    ];

    public gradeLevels = [
        { value: 'middle2', label: '중2' },
        { value: 'middle3', label: '중3' },
        { value: 'high', label: '고등' },
        { value: 'suneung', label: '수능' }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.loadSubjects();
        await this.loadList();
        await this.service.render();
    }

    // --- 탭 전환 ---
    public async switchTab(tab: string) {
        this.tab = tab;
        if (tab === 'list') await this.loadList();
        if (tab === 'stats') await this.loadStats();
        if (tab === 'create') {
            this.formMode = 'create';
            this.form = this.emptyForm();
            if (this.subjects.length > 0 && !this.form.subject_id) {
                this.form.subject_id = this.subjects[0].id;
                await this.loadFormChapters();
            }
        }
        await this.service.render();
    }

    // --- 과목/단원 로드 ---
    public async loadSubjects() {
        let res = await wiz.call("subjects");
        if (res.code === 200) this.subjects = res.data.subjects || [];
    }

    public async onSubjectChange() {
        this.filter.chapter_id = '';
        this.filter.topic_id = '';
        this.chapters = [];
        this.topics = [];
        if (this.filter.subject_id) {
            let res = await wiz.call("chapters", { subject_id: this.filter.subject_id });
            if (res.code === 200) this.chapters = res.data.chapters || [];
        }
        await this.service.render();
    }

    public async onChapterChange() {
        this.filter.topic_id = '';
        this.topics = [];
        if (this.filter.chapter_id) {
            let res = await wiz.call("topics", { chapter_id: this.filter.chapter_id });
            if (res.code === 200) this.topics = res.data.topics || [];
        }
        await this.service.render();
    }

    // --- 폼용 단원 로드 ---
    public formChapters: any[] = [];
    public formTopics: any[] = [];

    public async loadFormChapters() {
        this.formChapters = [];
        this.formTopics = [];
        this.form.chapter_id = '';
        this.form.topic_id = '';
        if (this.form.subject_id) {
            let res = await wiz.call("chapters", { subject_id: this.form.subject_id });
            if (res.code === 200) this.formChapters = res.data.chapters || [];
        }
        await this.service.render();
    }

    public async loadFormTopics() {
        this.formTopics = [];
        this.form.topic_id = '';
        if (this.form.chapter_id) {
            let res = await wiz.call("topics", { chapter_id: this.form.chapter_id });
            if (res.code === 200) this.formTopics = res.data.topics || [];
        }
        await this.service.render();
    }

    // --- 목록 로드 ---
    public async loadList() {
        this.loading = true;
        await this.service.render();
        let res = await wiz.call("list", this.filter);
        if (res.code === 200) {
            this.questions = res.data.rows || [];
            this.totalCount = res.data.total || 0;
        }
        this.loading = false;
        await this.service.render();
    }

    public async search() {
        this.filter.page = 1;
        await this.loadList();
    }

    public async resetFilter() {
        this.filter = {
            subject_id: '', chapter_id: '', topic_id: '',
            question_type: '', difficulty_min: '', difficulty_max: '',
            source_type: '', keyword: '', page: 1, dump: 20
        };
        this.chapters = [];
        this.topics = [];
        await this.loadList();
    }

    public async goPage(p: number) {
        this.filter.page = p;
        await this.loadList();
    }

    public get totalPages(): number {
        return Math.ceil(this.totalCount / this.filter.dump) || 1;
    }

    // --- 등록/수정 ---
    public emptyForm(): any {
        return {
            subject_id: '',
            chapter_id: '',
            topic_id: '',
            question_type: 'multiple_choice',
            difficulty: 3,
            grade_target: [],
            content: '',
            options: ['', '', '', '', ''],
            answer: '',
            explanation: '',
            source_type: 'self',
            source_year: '',
            source_detail: '',
            tags: [],
            status: 'active'
        };
    }

    public addOption() {
        this.form.options.push('');
        this.service.render();
    }

    public removeOption(i: number) {
        this.form.options.splice(i, 1);
        this.service.render();
    }

    public toggleGradeTarget(value: string) {
        const idx = this.form.grade_target.indexOf(value);
        if (idx >= 0) this.form.grade_target.splice(idx, 1);
        else this.form.grade_target.push(value);
        this.service.render();
    }

    public tagInput: string = '';
    public addTag() {
        const t = this.tagInput.trim();
        if (t && !this.form.tags.includes(t)) {
            this.form.tags.push(t);
            this.tagInput = '';
        }
        this.service.render();
    }
    public removeTag(i: number) {
        this.form.tags.splice(i, 1);
        this.service.render();
    }

    public async saveQuestion() {
        if (!this.form.content.trim()) {
            await this.service.alert.show({ title: '알림', message: '문제 내용을 입력해주세요.' });
            return;
        }
        if (!this.form.subject_id) {
            await this.service.alert.show({ title: '알림', message: '과목을 선택해주세요.' });
            return;
        }

        let payload: any = { ...this.form };
        payload.options = JSON.stringify(payload.options);
        payload.tags = JSON.stringify(payload.tags);
        payload.grade_target = JSON.stringify(payload.grade_target);
        payload.difficulty = String(payload.difficulty);

        let res: any;
        if (this.formMode === 'edit') {
            res = await wiz.call("update", payload);
        } else {
            res = await wiz.call("create", payload);
        }

        if (res.code === 200) {
            await this.service.alert.show({ title: '완료', message: this.formMode === 'edit' ? '수정되었습니다.' : '등록되었습니다.' });
            this.tab = 'list';
            await this.loadList();
        } else {
            await this.service.alert.show({ title: '오류', message: res.data?.message || '저장 실패' });
        }
        await this.service.render();
    }

    public async editQuestion(q: any) {
        let res = await wiz.call("get", { id: q.id });
        if (res.code === 200) {
            let item = res.data.item;
            this.formMode = 'edit';
            this.form = {
                id: item.id,
                subject_id: item.subject_id || '',
                chapter_id: item.chapter_id || '',
                topic_id: item.topic_id || '',
                question_type: item.question_type || 'multiple_choice',
                difficulty: item.difficulty || 3,
                grade_target: item.grade_target || [],
                content: item.content || '',
                options: item.options || ['', '', '', '', ''],
                answer: item.answer || '',
                explanation: item.explanation || '',
                source_type: item.source_type || 'self',
                source_year: item.source_year || '',
                source_detail: item.source_detail || '',
                tags: item.tags || [],
                status: item.status || 'active'
            };

            // JSON 문자열이면 parse
            if (typeof this.form.options === 'string') {
                try { this.form.options = JSON.parse(this.form.options); } catch(e) {}
            }
            if (typeof this.form.tags === 'string') {
                try { this.form.tags = JSON.parse(this.form.tags); } catch(e) {}
            }
            if (typeof this.form.grade_target === 'string') {
                try { this.form.grade_target = JSON.parse(this.form.grade_target); } catch(e) {}
            }

            this.tab = 'create';
            await this.loadFormChapters();
            this.form.chapter_id = item.chapter_id || '';
            if (this.form.chapter_id) {
                await this.loadFormTopics();
                this.form.topic_id = item.topic_id || '';
            }
        }
        await this.service.render();
    }

    public async deleteQuestion(id: string) {
        let res = await this.service.alert.show({
            title: '삭제 확인',
            message: '이 문제를 삭제하시겠습니까?',
            action: '삭제'
        });
        if (!res) return;
        let r = await wiz.call("delete", { id });
        if (r.code === 200) await this.loadList();
        await this.service.render();
    }

    // --- 통계 ---
    public async loadStats() {
        let res = await wiz.call("stats");
        if (res.code === 200) this.statsData = res.data;
        await this.service.render();
    }

    // --- 대량 등록 ---
    public async bulkUpload() {
        if (!this.bulkJson.trim()) {
            await this.service.alert.show({ title: '알림', message: 'JSON 데이터를 입력해주세요.' });
            return;
        }
        let res = await wiz.call("bulk_create", { questions: this.bulkJson });
        if (res.code === 200) {
            this.bulkResult = res.data;
        } else {
            await this.service.alert.show({ title: '오류', message: res.data?.message || '업로드 실패' });
        }
        await this.service.render();
    }

    // --- 유틸 ---
    public typeLabel(v: string): string {
        return this.questionTypes.find(t => t.value === v)?.label || v;
    }
    public diffLabel(v: number): string {
        return this.difficulties.find(d => d.value === v)?.label || `${v}`;
    }
    public sourceLabel(v: string): string {
        return this.sourceTypes.find(s => s.value === v)?.label || v;
    }
    public subjectName(id: string): string {
        return this.subjects.find(s => s.id === id)?.name || id;
    }

    public trackByIndex(index: number): number { return index; }
}

export default PageAdminQuestionsComponent;